import React from 'react';
export const CFIconLogIn = {
    alias: 'log-in',
    defaultTitle: 'Log In',
    source: ({ Path }) => (React.createElement(React.Fragment, null,
        React.createElement(Path, { d: 'M17 4h2c.55 0 1 .45 1 1v14c0 .55-.45 1-1 1h-2c-.55 0-1-.45-1-1s.45-1 1-1h1V6h-1c-.55 0-1-.45-1-1s.45-1 1-1Zm-6.6 3.2a1 1 0 0 1 1.4.2l3 4c.26.346.268.82.018 1.175l-2.814 4a.999.999 0 0 1-1.393.243 1 1 0 0 1-.243-1.394l1.718-2.442c-.014.002-.026.006-.039.01A.178.178 0 0 1 12 13H4a1 1 0 0 1 0-2h8.001L10.2 8.6a.999.999 0 0 1 .2-1.4Z' }))),
};
